export default __webpack_public_path__ + "static/media/picMain.314c58ce.png";